import React, { Component } from "react";
import { Empty, message } from "antd";
import axios from "axios";
import { connect } from "react-redux";
import HiloMensajes from "../../Whatsapp/Components/Chat/HiloMensajes";
import { mergeMensajes } from "../../../../Utils/whatsapp.utils";

class ChatLeadWhatsapp extends Component {
  state = { conversacion: null, mensajes: [], loading: true, enviando: false, hayMas: false, cargandoMas: false };

  get headers() {
    return { headers: this.props.headersToken };
  }

  componentDidMount() {
    this.cargar();
    window.addEventListener("whatsapp_event", this.handleEvent);
  }

  componentWillUnmount() {
    window.removeEventListener("whatsapp_event", this.handleEvent);
  }

  componentDidUpdate(prev) {
    if (prev.telefono !== this.props.telefono || prev.leadId !== this.props.leadId) {
      this.cargar();
    }
  }

  cargar = () => {
    const { telefono, leadId } = this.props;
    if (!telefono) {
      this.setState({ loading: false, conversacion: null, mensajes: [] });
      return;
    }
    this.setState({ loading: true });
    axios
      .post("whatsapp/conversacionLead", { telefono, leadId }, this.headers)
      .then((r) => {
        if (r.data.success === 2) {
          this.setState({
            conversacion: r.data.conversacion,
            mensajes: r.data.mensajes || [],
            hayMas: !!r.data.hayMas,
          });
        } else {
          this.setState({ conversacion: null, mensajes: [], hayMas: false });
        }
      })
      .finally(() => this.setState({ loading: false }));
  };

  // Refresca la última página y la combina sin perder lo ya cargado.
  recargarMensajes = () => {
    const conv = this.state.conversacion;
    if (!conv) return;
    axios
      .post("whatsapp/obtenerMensajes", { conversacionId: conv._id }, this.headers)
      .then((r) => {
        if (r.data.success === 2) {
          this.setState((prev) => ({ mensajes: mergeMensajes(prev.mensajes, r.data.mensajes || []) }));
        }
      });
  };

  // Antepone la página anterior (scroll infinito hacia arriba).
  cargarMasMensajes = () => {
    const { conversacion, mensajes, cargandoMas, hayMas } = this.state;
    const before = mensajes[0]?._id;
    if (!conversacion || cargandoMas || !hayMas || !before) return;
    this.setState({ cargandoMas: true });
    axios
      .post("whatsapp/obtenerMensajes", { conversacionId: conversacion._id, before }, this.headers)
      .then((r) => {
        if (r.data.success === 2) {
          this.setState((prev) => ({
            mensajes: mergeMensajes(r.data.mensajes || [], prev.mensajes),
            hayMas: !!r.data.hayMas,
          }));
        }
      })
      .finally(() => this.setState({ cargandoMas: false }));
  };

  handleEvent = (e) => {
    const data = e.detail || {};
    const conv = this.state.conversacion;
    if (!conv) return;
    if (data.tipo === "mensaje" && String(data.conversacionId) === String(conv._id)) {
      this.recargarMensajes();
    } else if (data.tipo === "estado") {
      this.setState((prev) => ({
        mensajes: prev.mensajes.map((m) =>
          m.waMessageId === data.waMessageId ? { ...m, estado: data.estado } : m,
        ),
      }));
    }
  };

  enviar = (texto) => {
    const conv = this.state.conversacion;
    if (!conv || !texto?.trim()) return;
    this.setState({ enviando: true });
    axios
      .post("whatsapp/enviarMensaje", { conversacionId: conv._id, texto }, this.headers)
      .then((r) => {
        if (r.data.success === 2) {
          this.setState((prev) => ({ mensajes: [...prev.mensajes, r.data.mensaje] }));
        } else if (r.data.success === 3) {
          message.warning("Fuera de la ventana de 24h. Usa una plantilla aprobada (próximamente).");
        } else {
          message.error(r.data.message || "Error al enviar el mensaje.");
        }
      })
      .catch(() => message.error("Error de red al enviar."))
      .finally(() => this.setState({ enviando: false }));
  };

  enviarMediaArchivo = (formData) => {
    this.setState({ enviando: true });
    const headers = { ...this.props.headersToken };
    delete headers["Content-Type"];
    axios
      .post("whatsapp/enviarMedia", formData, { headers })
      .then((r) => this.procesarRespuesta(r))
      .catch(() => message.error("Error de red al enviar."))
      .finally(() => this.setState({ enviando: false }));
  };

  enviarPlantilla = (formData) => {
    this.setState({ enviando: true });
    const headers = { ...this.props.headersToken };
    delete headers["Content-Type"];
    axios
      .post("whatsapp/enviarPlantilla", formData, { headers })
      .then((r) => this.procesarRespuesta(r))
      .catch(() => message.error("Error de red al enviar."))
      .finally(() => this.setState({ enviando: false }));
  };

  enviarServicio = (payload) => {
    this.setState({ enviando: true });
    let endpoint = "whatsapp/enviarServicio";
    let body = payload;
    if (payload.tipo === "insumo") {
      endpoint = "whatsapp/enviarInsumo";
    } else if (payload.tipo === "interactivo") {
      endpoint = "whatsapp/enviarInteractivo";
      body = {
        conversacionId: payload.conversacionId,
        tipo: payload.tipoInteractivo,
        payload: payload.payload,
      };
    }
    axios
      .post(endpoint, body, this.headers)
      .then((r) => this.procesarRespuesta(r))
      .catch(() => message.error("Error de red al enviar."))
      .finally(() => this.setState({ enviando: false }));
  };

  procesarRespuesta = (r) => {
    if (r.data.success === 2) {
      const nuevos = Array.isArray(r.data.mensajes) ? r.data.mensajes : [r.data.mensaje];
      this.setState((prev) => ({ mensajes: [...prev.mensajes, ...nuevos] }));
    } else if (r.data.success === 3) {
      message.warning("Fuera de la ventana de 24h. Usa una plantilla aprobada (próximamente).");
    } else {
      message.error(r.data.message || "No se pudo enviar.");
    }
  };

  render() {
    if (!this.props.telefono) {
      return <Empty description="El lead no tiene teléfono" style={{ padding: 30 }} />;
    }
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          height: this.props.height || "60vh",
          border: "1px solid #f0f0f0",
          borderRadius: 8,
          overflow: "hidden",
        }}
      >
        <HiloMensajes
          conversacion={this.state.conversacion}
          mensajes={this.state.mensajes}
          loading={this.state.loading}
          enviando={this.state.enviando}
          onEnviar={this.enviar}
          onEnviarMedia={this.enviarMediaArchivo}
          onEnviarServicio={this.enviarServicio}
          onEnviarPlantilla={this.enviarPlantilla}
          headersToken={this.props.headersToken}
          empresaId={this.props.empresaId}
          puedeGuardarPlantilla={this.props.permisoElementosWhatsapp}
          hayMas={this.state.hayMas}
          cargandoMas={this.state.cargandoMas}
          onCargarMas={this.cargarMasMensajes}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
  permisoElementosWhatsapp:
    state.user.tipo === 0 ||
    state.user.permisos.find(
      (valueTodos) => valueTodos.permisoId.toString() === "6a319b93047d1278102f2636",
    )?.activado,
});

export default connect(mapStateToProps)(ChatLeadWhatsapp);
